const hasValidationError = (validationErrors) =>
    Object.keys(validationErrors).some((key) =>
        typeof validationErrors[key] === 'object'
            ? hasValidationError(validationErrors[key])
            : Boolean(validationErrors[key]),
    );

export { hasValidationError };
